import type { AllSelectionListsWithSkillTaxonomyKey } from '../types/filters';

type SelectionListTreeNode = {
  id: string | number;
  name: string;
  children?: readonly SelectionListTreeNode[];
  levelId?: AllSelectionListsWithSkillTaxonomyKey;
};

export const flattenTreeToSelectionLists = (
  nodes: readonly SelectionListTreeNode[],
  selectionListIds: readonly AllSelectionListsWithSkillTaxonomyKey[]
) => {
  const listMap = new Map<
    AllSelectionListsWithSkillTaxonomyKey,
    Map<string, { id: string; shortName: string; longName: string }>
  >();

  for (const id of selectionListIds) {
    listMap.set(id, new Map());
  }

  const traverse = (currentNodes: readonly SelectionListTreeNode[]) => {
    for (const node of currentNodes) {
      if (node.levelId && listMap.has(node.levelId)) {
        const strId = String(node.id);
        const map = listMap.get(node.levelId);
        if (map && !map.has(strId)) {
          map.set(strId, {
            id: strId,
            shortName: node.name,
            longName: node.name,
          });
        }
      }
      if (node.children) {
        traverse(node.children);
      }
    }
  };

  traverse(nodes);

  return selectionListIds
    .map((id) => ({
      id,
      value: Array.from(listMap.get(id)?.values() ?? []),
    }))
    .filter((list) => list.value.length > 0);
};
